import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form'

import { cn } from '@/lib/utils'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

interface SwitchInputProps<T extends FieldValues> {
    control: Control<T>
    name: FieldPath<T>
    label: string
    description?: string
    rules?: RegisterOptions<T>
    disabled?: boolean
    className?: string
    activeValue?: any
    inactiveValue?: any
}

export function SwitchInput<T extends FieldValues>({
    control,
    name,
    label,
    description,
    rules,
    disabled = false,
    className = '',
    activeValue = true,
    inactiveValue = false,
}: SwitchInputProps<T>) {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field }) => (
                <div className={cn('flex items-center justify-between p-3 border rounded-lg', className)}>
                    <div className="space-y-0.5">
                        <Label className="text-sm cursor-pointer" htmlFor={name}>
                            {label}
                        </Label>
                        {description && <p className="text-xs text-muted-foreground">{description}</p>}
                    </div>
                    <Switch
                        id={name}
                        checked={field.value === activeValue}
                        onCheckedChange={(checked) => {
                            field.onChange(checked ? activeValue : inactiveValue)
                        }}
                        disabled={disabled}
                    />
                </div>
            )}
        />
    )
}
